import React, { useContext } from 'react';
import { MessageContext } from '../../locale/MessageProvider';
import { Button } from 'is24-corecss';
import DataCard from '../dataCard/DataCard';
import { FetchSandboxUser } from '@shared/api/dto/BoxUserDetails';

type SandboxAccountCreationProps = {
  sandboxUserDetails?: FetchSandboxUser;
  onClick?: () => void;
  className?: string;
};

enum fieldName {
  email = 'email',
  title = 'title',
  password = 'password',
  create = 'create',
}

const SandboxAccountCreation: React.FC<SandboxAccountCreationProps> = ({
  className,
  onClick,
  sandboxUserDetails,
}: SandboxAccountCreationProps) => {
  const messageFormatter = useContext(MessageContext);
  const PRO = process.env.STAGE === 'pro';
  return (
    <DataCard
      className={className}
      title={messageFormatter.formatMessage(SandboxAccountCreation, fieldName.title)}
      button={
        PRO ? (
          <Button data-testid="data-card-button-sandbox-details" textStyle={true} onClick={onClick}>
            {messageFormatter.formatMessage(SandboxAccountCreation, fieldName.create).toLowerCase()}
          </Button>
        ) : (
          <span></span>
        )
      }
    >
      {sandboxUserDetails && (
        <div className="grid grid-flex">
          <p className="one-whole padding-top-s">{'Username: ' + sandboxUserDetails?.username}</p>
          <p data-testid={fieldName.email} className="one-whole padding-top-s">
            {'Email: ' + sandboxUserDetails?.email}
          </p>
          <p data-testid={fieldName.password} className="one-whole padding-top-s">
            {'Password: ' + sandboxUserDetails?.password}
          </p>
        </div>
      )}
    </DataCard>
  );
};

export default SandboxAccountCreation;
